import { useState } from 'react'
import { ThemeStore, useThemeStore } from '@/store/theme'
import { Outlet, Link } from 'react-router-dom'
import Container from '@/components/Container'

export default function AuthLayout() {
    const [isLogoLoaded, setIsLogoLoaded] = useState<boolean>(false)
    const tenantTheme = useThemeStore((store: ThemeStore) => store.tenantTheme)

    return (
        <div className="min-h-screen bg-background flex flex-col">
            {/* Header */}
            <Container as="header" className="w-full py-4 flex items-center justify-between border-b border-secondary/10">
                <Link to="/" className="text-foreground font-bold text-2xl flex items-center gap-2 hover:opacity-80 transition-opacity">
                    <img
                        src={tenantTheme.logoUrl}
                        alt={`${tenantTheme.name} logo`}
                        className="h-7"
                        onLoad={() => setIsLogoLoaded(true)}
                        onError={() => setIsLogoLoaded(false)}
                        title={`${tenantTheme.name} logo`}
                        width={140}
                        height={28}
                    />
                    {!isLogoLoaded && <span className="uppercase">{tenantTheme.name}</span>}
                </Link>
            </Container>
            <Outlet />
        </div>
    )
}
